var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVkcloudinline = function SvgVkcloudinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.035 13.553h48.188v36.894H9.035z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    fillRule: "evenodd",
    d: "M10.8 19.467c.346 16.64 8.665 26.64 23.252 26.64h.826v-9.522c5.36.534 9.413 4.453 11.04 9.521h7.573c-2.08-7.573-7.547-11.76-10.96-13.36 3.413-1.973 8.213-6.773 9.357-13.28h-6.877c-1.495 5.28-5.92 10.08-10.133 10.534V19.467h-6.88V37.92c-4.266-1.067-9.653-6.24-9.893-18.453zM4.498 4.499C0 8.998 0 16.239 0 30.719v2.561C0 47.76 0 55.002 4.498 59.5 8.997 64 16.238 64 30.722 64h2.56c14.477 0 21.716 0 26.22-4.5C64.005 55.002 64 47.762 64 33.28v-2.56c0-14.479 0-21.718-4.498-26.221S47.759 0 33.278 0h-2.556C16.237 0 8.997 0 4.498 4.499",
    clipRule: "evenodd"
  })));
};
export default SvgVkcloudinline;